const postalCodes = require('./taiwan_districts.json');

module.exports = postalCodes;
